import {Component, OnInit} from '@angular/core';
import {EventService, EventDto} from 'src/app/services/event.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {switchMap, bufferCount, tap, map} from 'rxjs/operators';
import {Observable, from} from 'rxjs';
import {ShoppingCartService} from 'src/app/services/shopping-cart.service';
import {UserService, UserDto} from '../../services/user.service';
import {MatSnackBar} from '@angular/material';
import youtube_id from 'youtube-video-id';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit {
  events: Observable<EventDto[][]>;
  courses: Observable<EventDto[][]>;
  you: string;
  private static columnCount = 4;
  constructor(
    public eventService: EventService,
    public shoppingCartService: ShoppingCartService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {
    console.log('creating event list component');
  }

  ngOnInit() {
    this.events = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.userService.fetchUser(params.get('username')))
      , switchMap((user: UserDto) => {
          this.shoppingCartService.clientId = String(user.uid);
          this.shoppingCartService.companyDisplayName = String(user.displayName);
          this.shoppingCartService.companyPhoneNumber = String(user.mobileNo);
          this.shoppingCartService.companyEmailAddress = String(user.email);
          this.shoppingCartService.companyAddress = String(user.companyAddress);

          // console.log(JSON.stringify(this.shoppingCartService.basket));
          return from(this.eventService.fetchEvents(user.uid, 'EVENT'));
        }
      ),
      map( (s) => {
        return this.array_chunks(s,EventListComponent.columnCount);        
      }),
    );
    this.courses = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.userService.fetchUser(params.get('username')))
      , switchMap((user: UserDto) => {
          return from(this.eventService.fetchEvents(user.uid, 'COURSE'));
        }
      ),
      map( (s) => {
        return this.array_chunks(s,EventListComponent.columnCount);        
      }),
    );
  }
  array_chunks(array: any[], chunk_size: number) : any[][]{
    let a = array.map((_, i, all) => all.slice(i*chunk_size, (i+1)*chunk_size))
    .filter(x => x.length)
    return a;
  }
  add(e, event: EventDto) {
    e.preventDefault();
    console.log('adding to cart');
    this.shoppingCartService.addTicket(event);
    this.snackBar.open(
      `${event.eventName} added to your shopping cart.`, '',
      {
        duration: 1000,
      }
    );
  }
  
  print($event) {
    console.log('salam');
  }
  
  showDetail(event: EventDto) {
    this.eventService.selectedEvent = event;
    this.router.navigate([
      this.route.snapshot.params['username'], 'event-detail'
    ]);
  }


  checkout() {
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigate([
      this.route.snapshot.params['username'], 'checkout'
    ]);
  }

  get youtube(): string {
    return this.you;
  }

  set youtube(url: string) {
    this.you = youtube_id(url);
  }
}
